const REGION_ONE_COLORS = [
  "peach",
  "pink a",
  "pink b",
  "yellow",
  "black",
];

const REGION_TWO_COLORS = [
  "gold",
  "green",
  "grey",
  "maroon",
  "olive",
  "orange",
  "purple",
];

const REGION_THREE_COLORS = [
  "indigo",
  "red",
  "lavender",
  "turquoise",
  "white",
];

const REGION_PALETTE_MAP: Record<number, string[]> = {
  1: REGION_ONE_COLORS,
  2: REGION_TWO_COLORS,
  3: REGION_THREE_COLORS,
  4: [],
};

const REGION_INDEX_REGEX = /region\s*([1-4])/i;
const FALLBACK_INDEX_REGEX = /\b([1-4])\b/;

const COLOR_LABEL_MAP: Record<string, string> = {
  peach: "Peach",
  "pink a": "Pink A",
  "pink b": "Pink B",
  yellow: "Yellow",
  black: "Black",
  gold: "Gold",
  green: "Green",
  grey: "Grey",
  maroon: "Maroon",
  olive: "Olive",
  orange: "Orange",
  purple: "Purple",
  lavender: "Lavender",
  indigo: "Indigo",
  red: "Red",
  turquoise: "Turquoise",
  white: "White",
};

const CSS_COLOR_HEXES: Array<{ name: string; hex: string }> = [
  { name: "Alice Blue", hex: "#f0f8ff" },
  { name: "Antique White", hex: "#faebd7" },
  { name: "Aqua", hex: "#00ffff" },
  { name: "Aquamarine", hex: "#7fffd4" },
  { name: "Azure", hex: "#f0ffff" },
  { name: "Beige", hex: "#f5f5dc" },
  { name: "Bisque", hex: "#ffe4c4" },
  { name: "Black", hex: "#000000" },
  { name: "Blanched Almond", hex: "#ffebcd" },
  { name: "Blue", hex: "#0000ff" },
  { name: "Blue Violet", hex: "#8a2be2" },
  { name: "Brown", hex: "#a52a2a" },
  { name: "Burly Wood", hex: "#deb887" },
  { name: "Cadet Blue", hex: "#5f9ea0" },
  { name: "Chartreuse", hex: "#7fff00" },
  { name: "Chocolate", hex: "#d2691e" },
  { name: "Coral", hex: "#ff7f50" },
  { name: "Cornflower Blue", hex: "#6495ed" },
  { name: "Cornsilk", hex: "#fff8dc" },
  { name: "Crimson", hex: "#dc143c" },
  { name: "Cyan", hex: "#00ffff" },
  { name: "Dark Blue", hex: "#00008b" },
  { name: "Dark Cyan", hex: "#008b8b" },
  { name: "Dark Goldenrod", hex: "#b8860b" },
  { name: "Dark Gray", hex: "#a9a9a9" },
  { name: "Dark Green", hex: "#006400" },
  { name: "Dark Khaki", hex: "#bdb76b" },
  { name: "Dark Magenta", hex: "#8b008b" },
  { name: "Dark Olive Green", hex: "#556b2f" },
  { name: "Dark Orange", hex: "#ff8c00" },
  { name: "Dark Orchid", hex: "#9932cc" },
  { name: "Dark Red", hex: "#8b0000" },
  { name: "Dark Salmon", hex: "#e9967a" },
  { name: "Dark Sea Green", hex: "#8fbc8f" },
  { name: "Dark Slate Blue", hex: "#483d8b" },
  { name: "Dark Slate Gray", hex: "#2f4f4f" },
  { name: "Dark Turquoise", hex: "#00ced1" },
  { name: "Dark Violet", hex: "#9400d3" },
  { name: "Deep Pink", hex: "#ff1493" },
  { name: "Deep Sky Blue", hex: "#00bfff" },
  { name: "Dim Gray", hex: "#696969" },
  { name: "Dodger Blue", hex: "#1e90ff" },
  { name: "Fire Brick", hex: "#b22222" },
  { name: "Floral White", hex: "#fffaf0" },
  { name: "Forest Green", hex: "#228b22" },
  { name: "Fuchsia", hex: "#ff00ff" },
  { name: "Gainsboro", hex: "#dcdcdc" },
  { name: "Ghost White", hex: "#f8f8ff" },
  { name: "Gold", hex: "#ffd700" },
  { name: "Goldenrod", hex: "#daa520" },
  { name: "Gray", hex: "#808080" },
  { name: "Green", hex: "#008000" },
  { name: "Green Yellow", hex: "#adff2f" },
  { name: "Honeydew", hex: "#f0fff0" },
  { name: "Hot Pink", hex: "#ff69b4" },
  { name: "Indian Red", hex: "#cd5c5c" },
  { name: "Indigo", hex: "#4b0082" },
  { name: "Ivory", hex: "#fffff0" },
  { name: "Khaki", hex: "#f0e68c" },
  { name: "Lavender", hex: "#e6e6fa" },
  { name: "Lavender Blush", hex: "#fff0f5" },
  { name: "Lawn Green", hex: "#7cfc00" },
  { name: "Lemon Chiffon", hex: "#fffacd" },
  { name: "Light Blue", hex: "#add8e6" },
  { name: "Light Coral", hex: "#f08080" },
  { name: "Light Cyan", hex: "#e0ffff" },
  { name: "Light Goldenrod Yellow", hex: "#fafad2" },
  { name: "Light Gray", hex: "#d3d3d3" },
  { name: "Light Green", hex: "#90ee90" },
  { name: "Light Pink", hex: "#ffb6c1" },
  { name: "Light Salmon", hex: "#ffa07a" },
  { name: "Light Sea Green", hex: "#20b2aa" },
  { name: "Light Sky Blue", hex: "#87cefa" },
  { name: "Light Slate Gray", hex: "#778899" },
  { name: "Light Steel Blue", hex: "#b0c4de" },
  { name: "Light Yellow", hex: "#ffffe0" },
  { name: "Lime", hex: "#00ff00" },
  { name: "Lime Green", hex: "#32cd32" },
  { name: "Linen", hex: "#faf0e6" },
  { name: "Magenta", hex: "#ff00ff" },
  { name: "Maroon", hex: "#800000" },
  { name: "Medium Aquamarine", hex: "#66cdaa" },
  { name: "Medium Blue", hex: "#0000cd" },
  { name: "Medium Orchid", hex: "#ba55d3" },
  { name: "Medium Purple", hex: "#9370db" },
  { name: "Medium Sea Green", hex: "#3cb371" },
  { name: "Medium Slate Blue", hex: "#7b68ee" },
  { name: "Medium Spring Green", hex: "#00fa9a" },
  { name: "Medium Turquoise", hex: "#48d1cc" },
  { name: "Medium Violet Red", hex: "#c71585" },
  { name: "Midnight Blue", hex: "#191970" },
  { name: "Mint Cream", hex: "#f5fffa" },
  { name: "Misty Rose", hex: "#ffe4e1" },
  { name: "Moccasin", hex: "#ffe4b5" },
  { name: "Navajo White", hex: "#ffdead" },
  { name: "Navy", hex: "#000080" },
  { name: "Old Lace", hex: "#fdf5e6" },
  { name: "Olive", hex: "#808000" },
  { name: "Olive Drab", hex: "#6b8e23" },
  { name: "Orange", hex: "#ffa500" },
  { name: "Orange Red", hex: "#ff4500" },
  { name: "Orchid", hex: "#da70d6" },
  { name: "Pale Goldenrod", hex: "#eee8aa" },
  { name: "Pale Green", hex: "#98fb98" },
  { name: "Pale Turquoise", hex: "#afeeee" },
  { name: "Pale Violet Red", hex: "#db7093" },
  { name: "Papaya Whip", hex: "#ffefd5" },
  { name: "Peach Puff", hex: "#ffdab9" },
  { name: "Peru", hex: "#cd853f" },
  { name: "Pink", hex: "#ffc0cb" },
  { name: "Plum", hex: "#dda0dd" },
  { name: "Powder Blue", hex: "#b0e0e6" },
  { name: "Purple", hex: "#800080" },
  { name: "Rebecca Purple", hex: "#663399" },
  { name: "Red", hex: "#ff0000" },
  { name: "Rosy Brown", hex: "#bc8f8f" },
  { name: "Royal Blue", hex: "#4169e1" },
  { name: "Saddle Brown", hex: "#8b4513" },
  { name: "Salmon", hex: "#fa8072" },
  { name: "Sandy Brown", hex: "#f4a460" },
  { name: "Sea Green", hex: "#2e8b57" },
  { name: "Sea Shell", hex: "#fff5ee" },
  { name: "Sienna", hex: "#a0522d" },
  { name: "Silver", hex: "#c0c0c0" },
  { name: "Sky Blue", hex: "#87ceeb" },
  { name: "Slate Blue", hex: "#6a5acd" },
  { name: "Slate Gray", hex: "#708090" },
  { name: "Snow", hex: "#fffafa" },
  { name: "Spring Green", hex: "#00ff7f" },
  { name: "Steel Blue", hex: "#4682b4" },
  { name: "Tan", hex: "#d2b48c" },
  { name: "Teal", hex: "#008080" },
  { name: "Thistle", hex: "#d8bfd8" },
  { name: "Tomato", hex: "#ff6347" },
  { name: "Turquoise", hex: "#40e0d0" },
  { name: "Violet", hex: "#ee82ee" },
  { name: "Wheat", hex: "#f5deb3" },
  { name: "White", hex: "#ffffff" },
  { name: "White Smoke", hex: "#f5f5f5" },
  { name: "Yellow", hex: "#ffff00" },
  { name: "Yellow Green", hex: "#9acd32" },
];

export const COLOR_HEX_MAP: Record<string, string> = {
  peach: "#f2b8a0",
  "pink lighter": "#f7c8d8",
  "pink light": "#f7c8d8",
  "pink a": "#f7c8d8",
  "pink darker": "#e07a9a",
  "pink dark": "#e07a9a",
  "pink b": "#e07a9a",
  yellow: "#f6d365",
  black: "#111827",
  gold: "#d4af37",
  green: "#4caf50",
  grey: "#9ca3af",
  gray: "#9ca3af",
  maroon: "#7a1f1f",
  olive: "#808000",
  orange: "#f97316",
  purple: "#8b5cf6",
  lavender: "#c4b5fd",
  indigo: "#4f46e5",
  red: "#ef4444",
  turquoise: "#14b8a6",
  white: "#ffffff",
};

const COLOR_LABEL_BY_HEX = Object.keys(COLOR_LABEL_MAP).reduce(
  (acc, key) => {
    const hex = COLOR_HEX_MAP[key];
    if (hex) {
      const normalizedHex = hex.toLowerCase();
      if (!acc[normalizedHex]) {
        acc[normalizedHex] = COLOR_LABEL_MAP[key];
      }
    }
    return acc;
  },
  {} as Record<string, string>
);

const normalizeColorKey = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");

const toTitleCase = (value: string): string =>
  value.replace(/\b\w/g, (char) => char.toUpperCase());

const hexToRgb = (
  value: string
): { r: number; g: number; b: number } | null => {
  if (!isHexColor(value)) {
    return null;
  }
  const cleaned = value.replace("#", "").toLowerCase();
  if (cleaned.length === 3) {
    const r = parseInt(cleaned[0] + cleaned[0], 16);
    const g = parseInt(cleaned[1] + cleaned[1], 16);
    const b = parseInt(cleaned[2] + cleaned[2], 16);
    return { r, g, b };
  }
  const r = parseInt(cleaned.slice(0, 2), 16);
  const g = parseInt(cleaned.slice(2, 4), 16);
  const b = parseInt(cleaned.slice(4, 6), 16);
  return { r, g, b };
};

const getNearestCssColorName = (hex: string): string => {
  const rgb = hexToRgb(hex);
  if (!rgb) {
    return "Custom color";
  }

  let closestName = "Custom color";
  let smallestDistance = Number.POSITIVE_INFINITY;

  CSS_COLOR_HEXES.forEach(({ name, hex: cssHex }) => {
    const cssRgb = hexToRgb(cssHex);
    if (!cssRgb) {
      return;
    }
    const distance =
      (rgb.r - cssRgb.r) ** 2 +
      (rgb.g - cssRgb.g) ** 2 +
      (rgb.b - cssRgb.b) ** 2;
    if (distance < smallestDistance) {
      smallestDistance = distance;
      closestName = name;
    }
  });

  return closestName;
};

export const isHexColor = (value?: string | null): boolean => {
  if (!value) {
    return false;
  }
  return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value.trim());
};

export const normalizeColorValue = (value?: string | null): string => {
  if (!value) {
    return "";
  }
  const normalized = normalizeColorKey(value);
  if (isHexColor(normalized)) {
    return normalized.toLowerCase();
  }
  const mapped = COLOR_HEX_MAP[normalized];
  return mapped ? mapped.toLowerCase() : normalized;
};

export const getColorLabel = (value?: string | null): string => {
  if (!value) {
    return "Unassigned";
  }
  const normalized = normalizeColorKey(value);
  if (isHexColor(normalized)) {
    return (
      COLOR_LABEL_BY_HEX[normalized.toLowerCase()] ??
      getNearestCssColorName(normalized.toLowerCase())
    );
  }
  const mappedHex = COLOR_HEX_MAP[normalized];
  if (mappedHex) {
    return (
      COLOR_LABEL_BY_HEX[mappedHex.toLowerCase()] ??
      COLOR_LABEL_MAP[normalized] ??
      toTitleCase(normalized)
    );
  }
  return COLOR_LABEL_MAP[normalized] ?? toTitleCase(normalized);
};

export const resolveColorHex = (value?: string | null): string => {
  if (!value) {
    return "#9ca3af";
  }
  const normalized = normalizeColorKey(value);
  if (isHexColor(normalized)) {
    return normalized.toLowerCase();
  }
  return COLOR_HEX_MAP[normalized] ?? "#9ca3af";
};

export const resolveRegionColorPalette = (
  regionName?: string | null
): string[] => {
  if (!regionName) {
    return REGION_PALETTE_MAP[4];
  }
  const match =
    regionName.match(REGION_INDEX_REGEX) ?? regionName.match(FALLBACK_INDEX_REGEX);
  if (match) {
    const index = Number(match[1]);
    return REGION_PALETTE_MAP[index] || REGION_PALETTE_MAP[4];
  }
  return REGION_PALETTE_MAP[4];
};

export const getAllPaletteColors = (): string[] => {
  const colors = [
    ...REGION_ONE_COLORS,
    ...REGION_TWO_COLORS,
    ...REGION_THREE_COLORS,
  ];
  return Array.from(new Set(colors));
};

export const pickRandomColor = (colors: string[]): string | null => {
  if (colors.length === 0) {
    return null;
  }
  const index = Math.floor(Math.random() * colors.length);
  return colors[index];
};

export const generateRandomHexColor = (usedColors: Set<string>): string => {
  let attempts = 0;
  while (attempts < 20) {
    const color = `#${Math.floor(Math.random() * 0xffffff)
      .toString(16)
      .padStart(6, "0")}`;
    if (!usedColors.has(normalizeColorValue(color))) {
      return color;
    }
    attempts += 1;
  }
  return "#6b7280";
};
